import { useState } from 'react';
import { EarconName, useEarcon } from '../../../hooks/useEarcon';
import { addBundle } from '../../../locale/createUseTextLocalizer';
import { getTextLocalizer } from '../../../locale/useTextLocalizer';
import { validateTextInput } from '../useInputValidationAdapter';
import bundle from '../NovaComponents-Input-gui-icu.properties';
addBundle(bundle);
let localize;
getTextLocalizer('NovaComponents-Input-gui-icu').then(localizer => {
  localize = localizer;
});

/**
 * Telephone Validation
 */

export const validateTelephoneInput = props => {
  let isError = false,
    status = undefined,
    message = undefined;
  const liveRegex = props.liveTelephoneRegex || /^[\d|\+\d{1,3}\s|\(]+[\)|\d|\s|\-|\.]{0,}$/;

  /**
   * ^\s*                #Line start, match any whitespaces at the beginning if any.
   * (?:\+?(\d{1,3}))?   #GROUP 1: The country code. Optional.
   * [-. (]*             #Allow certain non numeric characters that may appear between the Country Code and the Area Code.
   * (\d{3})             #GROUP 2: The Area Code. Required.
   * [-. )]*             #Allow certain non numeric characters that may appear between the Area Code and the Exchange number.
   * (\d{3})             #GROUP 3: The Exchange number. Required.
   * [-. ]*              #Allow certain non numeric characters that may appear between the Exchange number and the Subscriber number.
   * (\d{4})             #Group 4: The Subscriber Number. Required.
   * (?: *x(\d+))?       #Group 5: The Extension number. Optional.
   * \s*$                #Match any ending whitespaces if any and the end of string.
   */
  const telephoneRegex = props.telephoneRegex || /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
  const result = validateTextInput({
    value: props.value,
    isRequired: props.isRequired,
    minLength: props.minLength
  });
  if (result.isError) {
    ({
      isError,
      status,
      message
    } = result);
  } else {
    if (props.value) {
      if (!props.isLive) {
        if (!new RegExp(telephoneRegex).test(props.value)) {
          isError = true;
          status = 'alert';
          message = props.message || localize('telephoneValidator.msg');
        }
      } else {
        if (!new RegExp(liveRegex).test(props.value)) {
          isError = true;
          status = 'alert';
          message = props.message || localize('telephoneValidator.msg');
        }
      }
    }
  }
  return {
    isError,
    status,
    message
  };
};
/**
 * This hook provide functionality to handle events such as onChange,onBlur
 * & onCancel with empty initial value.
 * For those who doesn't wish to use this,
 * @function validateTelephoneInput is available for consumption
 * @param props
 *
 */
export const useTelephoneValidationAdapter = props => {
  const earcon = useEarcon({
    source: EarconName.Error
  });
  const [value, setValue] = useState('');
  const [errors, setErrors] = useState({
    status: undefined,
    message: ''
  });
  const handleChange = event => {
    const liveValue = event.value;
    const result = validateTelephoneInput({
      value: liveValue,
      isLive: true,
      isRequired: props.isRequired,
      message: props.message,
      telephoneRegex: props.telephoneRegex,
      liveTelephoneRegex: props.liveTelephoneRegex,
      minLength: props.minLength
    });
    setValue(liveValue);
    result.isError ? setErrors({
      status: result.status,
      message: result.message
    }) : setErrors({
      status: undefined,
      message: undefined
    });
    if (result.status === 'alert') earcon.play();
  };
  const handleCommit = e => {
    // setTimeout is needed here to work with FocusLock.
    setTimeout(() => {
      const result = validateTelephoneInput({
        value,
        isLive: false,
        isRequired: props.isRequired,
        message: props.message,
        telephoneRegex: props.telephoneRegex,
        liveTelephoneRegex: props.liveTelephoneRegex,
        minLength: props.minLength
      });
      result.isError && setErrors({
        status: result.status,
        message: result.message
      });
      if (result.status === 'alert' && e?.reason === 'enter') earcon.play();
    }, 0);
  };
  const handleBlur = handleCommit;
  const handleCancel = () => {
    setValue('');
    setErrors({
      status: undefined,
      message: undefined
    });
  };
  return {
    handleChange,
    value,
    errors,
    handleBlur,
    handleCancel,
    handleCommit
  };
};
//# sourceMappingURL=useTelephoneValidationAdapter.js.map